import {
    useSyncExternalStore,
    createContext,
    useContext
} from "react";
import type {
    TreeViewContextType,
    TreeViewSnapshot,
    TreeViewStore
} from "./type";

export const TreeViewContext = createContext<TreeViewContextType | null>(null);

export const useTreeViewContext = (): TreeViewContextType => {
    const context = useContext(TreeViewContext);

    if(!context) {
        throw new Error("TreeView: an internal part was rendered outside of a TreeView.");
    }

    return context;
};

export const createTreeViewStore = (initialSnapshot: TreeViewSnapshot): TreeViewStore => {
    const listeners = new Set<() => void>();

    let snapshot = initialSnapshot;

    return {
        notify: () => {
            listeners.forEach((listener) => listener());
        },
        subscribe: (listener) => {
            listeners.add(listener);

            return () => {
                listeners.delete(listener);
            };
        },
        setSnapshot: (nextSnapshot) => {
            snapshot = nextSnapshot;
        },
        getSnapshot: () => snapshot
    };
};

export const useTreeViewSelector = <T, >(selector: (snapshot: TreeViewSnapshot) => T): T => {
    const {
        store
    } = useTreeViewContext();

    const getSelection = () => selector(store.getSnapshot());

    return useSyncExternalStore(store.subscribe, getSelection, getSelection);
};
